
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class ReportPendingPRDtDialog extends  Serenity.Extensions.GridEditorDialog<ReportPendingPRDtRow> {
        protected getFormKey() { return ReportPendingPRDtForm.formKey; }
        protected getIdProperty() { return ReportPendingPRDtRow.idProperty; }
        protected getLocalTextPrefix() { return ReportPendingPRDtRow.localTextPrefix; }
        protected getNameProperty() { return ReportPendingPRDtRow.nameProperty; }
        protected getService() { return ReportPendingPRDtService.baseUrl; }
        protected getDeletePermission() { return ReportPendingPRDtRow.deletePermission; }
        protected getInsertPermission() { return ReportPendingPRDtRow.insertPermission; }
        protected getUpdatePermission() { return ReportPendingPRDtRow.updatePermission; }

        protected form = new ReportPendingPRDtForm(this.idPrefix);
        protected getToolbarButtons(): Serenity.ToolButton[] {

            let buttons = super.getToolbarButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
           buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
           buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
           return buttons;


   }

    }
}